import React, { useEffect, useMemo, useState } from 'react'
import './TruckAssetDetails.css'

const TruckAssetsDetails = ({ truckAssetDetails }) => {
    const assetDetails = useMemo(
        () => truckAssetDetails?.truck_asset_details ?? [],
        [truckAssetDetails]
    )

    const initialIndex = useMemo(() => {
        const highlighted = assetDetails.findIndex(a => a.isHighlighted)
        return highlighted >= 0 ? highlighted : 0
    }, [assetDetails])

    const [selectedIndex, setSelectedIndex] = useState(initialIndex)

    useEffect(() => {
        setSelectedIndex(initialIndex)
    }, [initialIndex])

    if (assetDetails.length === 0) {
        return (
            <div>
                <h3 className="data_header">Truck / Asset Details</h3>
                <div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <h4 className="click_notice">Click on Truck type to get Asset Details</h4>
                        </div>
                    </div>
                    <p>Details not available</p>
                </div>
            </div>
        )
    }

    const selected = assetDetails[selectedIndex] ?? assetDetails[0]

    return (
        <div>
            <h3 className="data_header">Truck / Asset Details</h3>
            <div className="asset_body">
                <div className="truckType">
                    <div className="row">
                        <div className="col-12 text-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '2%' }}>
                            Asset Type (Click to see details)
                        </div>
                    </div>
                    {assetDetails.map((asset, index) => (
                        <div
                            key={index}
                            className="asset"
                            tabIndex={index}
                            onClick={() => setSelectedIndex(index)}
                            style={{
                                backgroundColor: index === selectedIndex ? 'lightgreen' : 'white',
                                color: 'black',
                                cursor: 'pointer',
                            }}
                        >
                            <span className="assetName"> {asset.type} </span>
                        </div>
                    ))}
                </div>

                <div id="variableDataDivision">
                    <div className="row">
                        <div className="col-12 text-center" style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '2%' }}>
                            Asset Details: <b id="show_name">{selected.type}</b>
                        </div>
                    </div>
                    <div className="attribute">
                        <span className="attributeName">Self Owned:  </span>
                        <span className="attributeValue" id="selfOwned">{selected.self_owned} </span>
                    </div>
                    <div className="attribute">
                        <span className="attributeName">Average age of Fleet(in years):  </span>
                        <span className="attributeValue" id="avgFleet">{selected.avg_fleet_age} </span>
                    </div>
                    <div className="attribute">
                        <span className="attributeName">Planned Increase(next 12 months): </span>
                        <span className="attributeValue" id="plannedIncrease">{selected.planned_increase} </span>
                    </div>
                    <div className="attribute">
                        <span className="attributeName">Attached Vehicles: </span>
                        <span className="attributeValue" id="attachedVehicles">{selected.attached_vehicles} </span>
                    </div>
                    <div className="attribute">
                        <span className="attributeName">Major Vendors: </span>
                        <span className="attributeValue" id="vendor">{selected.vendors} </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TruckAssetsDetails
